import * as Yup from 'yup'

export const IndJobSchema = Yup.object({
    streetAddress:Yup.string().required('INPUT.VALIDATION.INDIVIDUAL.STREET.ADDRESS'),
    unitorapt:Yup.string(),
    description:Yup.string().required('INPUT.VALIDATION.INDIVIDUAL.DESCRIPTION'),
    schedule_date:Yup.mixed()
    .required('INPUT.VALIDATION.INDIVIDUAL.SCHEDULEDATE')
    .test('not-in-past', 'INPUT.VALIDATION.INDIVIDUAL.SCHEDULEDATE.PAST', (value) => {
        if (!value) return false;
        const parsedDate = new Date(value);
        if (isNaN(parsedDate.getTime())) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        parsedDate.setHours(0, 0, 0, 0);
        return parsedDate >= today;
    }),

})
